<template>
<div class="cf">
  <div class="fl w-100">
    <h1 class="page-header f4 f2-l">Support</h1>
    <!-- Inner Main Wrapper -->
    <div class="flex flex-row flex-wrap flex-nowrap-l">
      <!-- Self Serve column -->
      <div class="flex flex-column w-100 w-60-l mr3-l">
        <!-- Forums -->
        <transition name="EnterFromAbove" appear>
          <div class="fl w-100 ba b--dark-gray">
            <div class="pa1 bb b--gray b1 ">
              <h2 class="ph2 pt1 mb1 mt0 f5 f3-l fw3">Community Support Forums</h2>
            </div>
            <div class="flex flex-row flex-wrap items-center justify-center pa3">
              <img class="h3 w3" src="@/assets/CommunitySupportIcon.png" alt="Community Support Forums">
              <p class="f6 ph3-l w-40-l light-silver">Get help from the community in our official forums for any Block and Chain Studio game.</p>
              <div class="w-30-l">
                <a class="no-underline grow dib v-mid ba cta-button-sm" href="https://community.haloplatform.tech/forum/29-game-questions/" target="_blank">Open Forums</a>
              </div>
            </div>
          </div>
        </transition>
        <!-- FAQ -->
        <transition name="appearsecond" appear>
          <div class="fl w-100 ba b--dark-gray mt3 relative">
            <div class="pa1 bb b--gray">
              <h2 class="ml5 ph2 pt1 mb1 mt0 f3 fw3">FAQs</h2>
            </div>
            <div class="tc contact-bubble absolute ba b--gray br-100 h3 w3">
              <i class="gold-color fas fa-question"></i>
            </div>
            <!-- Generate list -->
            <div class="pv3 ph1 pa3-l">
              <div>
                <transition-group>
                  <template v-for="faq in faqs">
                    <div @click="faq.show = !faq.show" :key="faq.id" class="faq-list-item db">
                      <button class="light-silver mv1 pointer faq-item-q dib f6 f5-l tl">{{ faq.q }}</button>
                      <div class="ml4 mb2" v-if="faq.show">{{ faq.a }}</div>
                    </div>
                  </template>
                </transition-group>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- End Self Serve column -->
      <!-- Right column -->
      <div class="flex flex-column w-100 w-40-l mt3 mt0-l">
        <!-- Contact Form -->
        <transition name="appearthird" appear>
        <div class="bg-component pb3 relative">
          <div class="pa1 bb b--gray">
            <h2 class="ml5 ph2 pt1 mb1 mt0 f3 fw3">Contact Us</h2>
          </div>
          <div class="tc contact-bubble absolute ba b--gray br-100 h3 w3">
            <i class="gold-color far fa-envelope"></i>
          </div>
          <form class="pb3 ph2 ph4-m ph0-l" action="https://formspree.io/bnc@blockandchain.games" method="POST" novalidate>
            <fieldset id="contact" class="ph1 ph4-l ba b--transparent ph0 mh0 mb2">
              <div class="mt3 ph3 ph0-l">
                <!-- <label class="db lh-copy f6" htmlFor="email-address">Username</label>-->
                  <input
                    v-model="name"
                    class="pt2 input-reset ba white bg-transparent hover-gold w-100"
                    type="text"
                    placeholder="Your Name"
                    required
                   />
               </div>
               <div class="mt3 ph3 ph0-l">
                  <input
                    v-model="email"
                    class="pt2 input-reset ba white bg-transparent hover-gold w-100"
                    type="email"
                    placeholder="Email Address"
                    required
                   />
              </div>
              <div class="mt3 ph3 ph0-l">
                  <input
                    v-model="subject"
                    class="pt2 input-reset ba white bg-transparent hover-gold w-100"
                    type="text"
                    placeholder="Subject"
                    required
                   />
              </div>
              <div class="mt3 ph3 ph0-l">
                <textarea
                  v-model="message"
                  rows="4"
                  class="pt2 input-reset ba white bg-transparent hover-gold w-100"
                  type="text"
                  placeholder="How can we help?"
                  required
                ></textarea>
              </div>
            </fieldset>
            <div class="ph4 w-50">
              <button class="w-100 pv2 ph3 input-reset ba br3 white cta-button grow pointer f5 dib" type="submit" value="Send">Submit</button>
            </div>
          </form>
        </div>
        </transition>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'support',
  data: () => ({
    name: '',
    email: '',
    subject: '',
    message: '',
    faqs: [
      {
        "id": 1,
        "q": "I forgot my username or password. How can I log in?",
        "a": "Please contact us through the form on this page and we'll get you some help.",
        "show": false
      },
      {
        "id": 2,
        "q": "Do I need a Halo wallet to play?",
        "a": "A Halo wallet is not needed to play. However, the sign in process is very easy with a wallet.",
        "show": false
      },
      {
        "id": 3,
        "q": "What cryptocurrencies can I use in the games?",
        "a": "Currently, HALO and Ethereum can be used.",
        "show": false
      },
      {
        "id": 4,
        "q": "How do I play with cryptocurrencies?",
        "a": "Deposit cryptocurrency funds through the Crypto Cage, located in the games or in your profile page.",
        "show": false
      }
    ]
  }),
  /* eslint-disable */
  created: function () {
    window.zESettings = {
      webWidget: {
        color: {
          theme: '#BCA06F'
        }
      }
    };
      /*<![CDATA[*/window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement("iframe");window.zEmbed=function(){a.push(arguments)},window.zE=window.zE||window.zEmbed,r.src="javascript:false",r.title="",r.role="presentation",(r.frameElement||r).style.cssText="display: none",d=document.getElementsByTagName("script"),d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s}catch(e){n=document.domain,r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',o=s}o.open()._l=function(){var e=this.createElement("script");n&&(this.domain=n),e.id="js-iframe-async",e.src="https://assets.zendesk.com/embeddable_framework/main.js",this.t=+new Date,this.zendeskHost="haloplatform.zendesk.com",this.zEQueue=a,this.body.appendChild(e)},o.write('<body onload="document._l();">'),o.close()}();    /*]]>*/
  },
}
</script>

<style lang="scss" scoped>
.contact-bubble {
  top: -9px;
  left: 7px;
  background-color: #25242c;
}
.contact-bubble i {
  font-size: 28px;
  margin-top: 27%;
}
.faq-item-q {
  transition: 300ms;
  background-color: none;
}
.faq-item-q:hover {
  transform: translateX(10px)
}
.faq-list-item {
  transition: all .5s;
}
.faq-list-item button {
  background: none;
  border: none;
}
/*.faq-list-leave-active {
  position: absolute;
}*/
</style>
